const setPlainText = (str) => {
  for (var i = 0; i < str.length; i++) {
    if (str.charAt(i) == 'Ã') str = str.replace(/Ã/, 'A');
    if (str.charAt(i) == 'À') str = str.replace(/À/, 'A');
    if (str.charAt(i) == 'Á') str = str.replace(/Á/, 'A');
    if (str.charAt(i) == 'Ä') str = str.replace(/Ä/, 'A');
    if (str.charAt(i) == 'Â') str = str.replace(/Â/, 'A');
    if (str.charAt(i) == 'È') str = str.replace(/È/, 'E');
    if (str.charAt(i) == 'É') str = str.replace(/É/, 'E');
    if (str.charAt(i) == 'Ë') str = str.replace(/Ë/, 'E');
    if (str.charAt(i) == 'Ê') str = str.replace(/Ê/, 'E');
    if (str.charAt(i) == 'Ì') str = str.replace(/Ì/, 'I');
    if (str.charAt(i) == 'Í') str = str.replace(/Í/, 'I');
    if (str.charAt(i) == 'Ï') str = str.replace(/Ï/, 'I');
    if (str.charAt(i) == 'Î') str = str.replace(/Î/, 'I');
    if (str.charAt(i) == 'Ò') str = str.replace(/Ò/, 'O');
    if (str.charAt(i) == 'Ó') str = str.replace(/Ó/, 'O');
    if (str.charAt(i) == 'Ö') str = str.replace(/Ö/, 'O');
    if (str.charAt(i) == 'Ô') str = str.replace(/Ô/, 'O');
    if (str.charAt(i) == 'Ù') str = str.replace(/Ù/, 'U');
    if (str.charAt(i) == 'Ú') str = str.replace(/Ú/, 'U');
    if (str.charAt(i) == 'Ü') str = str.replace(/Ü/, 'U');
    if (str.charAt(i) == 'Û') str = str.replace(/Û/, 'U');
    if (str.charAt(i) == 'ã') str = str.replace(/ã/, 'a');
    if (str.charAt(i) == 'à') str = str.replace(/à/, 'a');
    if (str.charAt(i) == 'á') str = str.replace(/á/, 'a');
    if (str.charAt(i) == 'ä') str = str.replace(/ä/, 'a');
    if (str.charAt(i) == 'â') str = str.replace(/â/, 'a');
    if (str.charAt(i) == 'è') str = str.replace(/è/, 'e');
    if (str.charAt(i) == 'é') str = str.replace(/é/, 'e');
    if (str.charAt(i) == 'ë') str = str.replace(/ë/, 'e');
    if (str.charAt(i) == 'ê') str = str.replace(/ê/, 'e');
    if (str.charAt(i) == 'ì') str = str.replace(/ì/, 'i');
    if (str.charAt(i) == 'í') str = str.replace(/í/, 'i');
    if (str.charAt(i) == 'ï') str = str.replace(/ï/, 'i');
    if (str.charAt(i) == 'î') str = str.replace(/î/, 'i');
    if (str.charAt(i) == 'ò') str = str.replace(/ò/, 'o');
    if (str.charAt(i) == 'ó') str = str.replace(/ó/, 'o');
    if (str.charAt(i) == 'ö') str = str.replace(/ö/, 'o');
    if (str.charAt(i) == 'ô') str = str.replace(/ô/, 'o');
    if (str.charAt(i) == 'ù') str = str.replace(/ù/, 'u');
    if (str.charAt(i) == 'ú') str = str.replace(/ú/, 'u');
    if (str.charAt(i) == 'ü') str = str.replace(/ü/, 'u');
    if (str.charAt(i) == 'û') str = str.replace(/û/, 'u');
    if (str.charAt(i) == 'Ñ') str = str.replace(/Ñ/, 'n');
    if (str.charAt(i) == 'ñ') str = str.replace(/ñ/, 'n');
    if (str.charAt(i) == 'Ç') str = str.replace(/Ç/, 'c');
    if (str.charAt(i) == 'ç') str = str.replace(/ç/, 'c');
    if (str.charAt(i) == "'") str = str.replace(/'/, '');
    if (str.charAt(i) == ' ') str = str.replace(/ /, '');
  }
  return str;
};

const validCURP = (value) => {
  return /^[A-Z]{1}[AEIOUX]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}$/.test(
    value
  );
};

const setIdBusqueda = (s) => {
  let id_busqueda = setPlainText(s).toLowerCase();
  id_busqueda = id_busqueda.toLowerCase();
  return id_busqueda;
};

const setLegibleDate = (date_iso) => {
  const _days = [
    '??',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
  ];
  const _months = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
  ];

  let theDate = new Date(date_iso);

  return `${_days[theDate.getDate()]}/${
    _months[theDate.getMonth()]
  }/${theDate.getFullYear()}`;
};

const setLegiblePrice = (value) =>
  value.toLocaleString('es-MX', {
    style: 'currency',
    currency: 'MXN',
  });

const Unidades = (num) => {
  switch (num) {
    case 1:
      return 'UN';
    case 2:
      return 'DOS';
    case 3:
      return 'TRES';
    case 4:
      return 'CUATRO';
    case 5:
      return 'CINCO';
    case 6:
      return 'SEIS';
    case 7:
      return 'SIETE';
    case 8:
      return 'OCHO';
    case 9:
      return 'NUEVE';
  }

  return '';
};

const Decenas = (num) => {
  let decena = Math.floor(num / 10);
  let unidad = num - decena * 10;

  switch (decena) {
    case 1:
      switch (unidad) {
        case 0:
          return 'DIEZ';
        case 1:
          return 'ONCE';
        case 2:
          return 'DOCE';
        case 3:
          return 'TRECE';
        case 4:
          return 'CATORCE';
        case 5:
          return 'QUINCE';
        default:
          return 'DIECI' + Unidades(unidad);
      }
    case 2:
      switch (unidad) {
        case 0:
          return 'VEINTE';
        default:
          return 'VEINTI' + Unidades(unidad);
      }
    case 3:
      return DecenasY('TREINTA', unidad);
    case 4:
      return DecenasY('CUARENTA', unidad);
    case 5:
      return DecenasY('CINCUENTA', unidad);
    case 6:
      return DecenasY('SESENTA', unidad);
    case 7:
      return DecenasY('SETENTA', unidad);
    case 8:
      return DecenasY('OCHENTA', unidad);
    case 9:
      return DecenasY('NOVENTA', unidad);
    case 0:
      return Unidades(unidad);
  }
};

const DecenasY = (strSin, numUnidades) => {
  if (numUnidades > 0) return strSin + ' Y ' + Unidades(numUnidades);

  return strSin;
};

const Centenas = (num) => {
  let centenas = Math.floor(num / 100);
  let decenas = num - centenas * 100;

  switch (centenas) {
    case 1:
      if (decenas > 0) return 'CIENTO ' + Decenas(decenas);
      return 'CIEN';
    case 2:
      return 'DOSCIENTOS ' + Decenas(decenas);
    case 3:
      return 'TRESCIENTOS ' + Decenas(decenas);
    case 4:
      return 'CUATROCIENTOS ' + Decenas(decenas);
    case 5:
      return 'QUINIENTOS ' + Decenas(decenas);
    case 6:
      return 'SEISCIENTOS ' + Decenas(decenas);
    case 7:
      return 'SETECIENTOS ' + Decenas(decenas);
    case 8:
      return 'OCHOCIENTOS ' + Decenas(decenas);
    case 9:
      return 'NOVECIENTOS ' + Decenas(decenas);
  }

  return Decenas(decenas);
};

const Seccion = (num, divisor, strSingular, strPlural) => {
  let cientos = Math.floor(num / divisor);
  let resto = num - cientos * divisor;

  let letras = '';

  if (cientos > 0)
    if (cientos > 1) letras = Centenas(cientos) + ' ' + strPlural;
    else letras = strSingular;

  if (resto > 0) letras += '';

  return letras;
};

const Miles = (num) => {
  let divisor = 1000;
  let cientos = Math.floor(num / divisor);
  let resto = num - cientos * divisor;

  let strMiles = Seccion(num, divisor, 'UN MIL', 'MIL');
  let strCentenas = Centenas(resto);

  if (strMiles === '') return strCentenas;

  return strMiles + ' ' + strCentenas;
};

const Millones = (num) => {
  let divisor = 1000000;
  let cientos = Math.floor(num / divisor);
  let resto = num - cientos * divisor;

  let strMillones = Seccion(num, divisor, 'UN MILLON DE', 'MILLONES DE');
  let strMiles = Miles(resto);

  if (strMillones === '') return strMiles;

  return strMillones + ' ' + strMiles;
};

const convertNumbersToLetters = (num) => {
  var data = {
    numero: num,
    enteros: Math.floor(num),
    centavos: Math.round(num * 100) - Math.floor(num) * 100,
    letrasCentavos: '',
    letrasMonedaPlural: 'PESOS', //"PESOS", 'Dólares', 'Bolívares', 'etcs'
    letrasMonedaSingular: 'PESO', //"PESO", 'Dólar', 'Bolivar', 'etc'

    letrasMonedaCentavoPlural: 'CENTAVOS',
    letrasMonedaCentavoSingular: 'CENTAVO',
  };

  if (data.centavos > 0) {
    data.letrasCentavos =
      'CON ' +
      (function () {
        if (data.centavos === 1)
          return (
            Millones(data.centavos) + ' ' + data.letrasMonedaCentavoSingular
          );
        else
          return Millones(data.centavos) + ' ' + data.letrasMonedaCentavoPlural;
      })();
  }

  if (data.enteros === 0)
    return 'CERO ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos;
  if (data.enteros === 1)
    return (
      Millones(data.enteros) +
      ' ' +
      data.letrasMonedaSingular +
      ' ' +
      data.letrasCentavos
    );
  else
    return (
      Millones(data.enteros) +
      ' ' +
      data.letrasMonedaPlural +
      ' ' +
      data.letrasCentavos
    );
};

const meses = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

const setLegibleDatePlainText = (isoString) => {
  const fecha = new Date(isoString);
  if (isNaN(fecha)) {
    throw new Error('Fecha ISO inválida');
  }

  const day = fecha.getUTCDate(); // día del mes
  const year = fecha.getUTCFullYear();

  const mesNombre = meses[fecha.getUTCMonth()];

  return `${day} de ${mesNombre} del año ${year}`;
};

const setLegibleDatePlainTextLarge = (isoString) => {
  const fecha = new Date(isoString);
  const dia = fecha.getDate();
  const mes = meses[fecha.getMonth()];
  const anio = fecha.getFullYear();
  return `${dia === 1 ? 'al' : 'a los'} ${dia} ${
    dia === 1 ? 'día' : 'días'
  } del mes de ${mes} del año ${anio}`;
};

export default {
  setPlainText,
  validCURP,
  setIdBusqueda,
  setLegibleDate,
  setLegiblePrice,
  convertNumbersToLetters,
  converTensToLetters: Decenas,
  setLegibleDatePlainText,
  setLegibleDatePlainTextLarge,
};
